import { render, staticRenderFns } from "./EnviarCorreo.vue?vue&type=template&id=8bf8cbac"
import script from "./EnviarCorreo.vue?vue&type=script&lang=ts"
export * from "./EnviarCorreo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports